import {Serializable} from '../deserialize.service';
import * as _ from 'lodash';

export class Resource implements Serializable<Resource> {
    id: any;
    eventColor: string;
    eventBackgroundColor: string;
    eventBorderColor: string;
    eventTextColor: string;
    eventClassName: string;
    businessHours: any;
    children: string;
    parentId: boolean = false;
    parent: boolean = false;

    deserialize(input) {
        if (_.isNil(input)) {
            return this;
        }
        this.id = input.id;
        this.eventColor = input.eventColor;
        this.eventBackgroundColor = input.eventBackgroundColor;
        this.eventBorderColor = input.eventBorderColor;
        this.eventTextColor = input.eventTextColor;
        this.eventClassName = input.eventClassName;
        this.businessHours = input.businessHours;
        this.children = input.children;
        this.parentId = input.parentId;
        this.parent = input.parent;

        return this;
    }
}
